module.exports = __webpack_public_path__ + "img/205.325be294.jpg";